import { useEffect } from 'react';

/**
 * Close on Escape.
 *
 * A modal a keyboard user cannot dismiss without finding the close button is a
 * modal they are stuck in. Registered on the document rather than the dialog so
 * it works wherever focus happens to be inside it.
 */
export function useEscapeToClose(onClose: () => void): void {
  useEffect(() => {
    const onKeyDown = (event: KeyboardEvent) => {
      if (event.key === 'Escape') onClose();
    };
    document.addEventListener('keydown', onKeyDown);
    return () => document.removeEventListener('keydown', onKeyDown);
  }, [onClose]);
}
